/**
 * 타이핑 인디케이터 컴포넌트
 * 채점봇이 메시지를 입력 중일 때 표시되는 애니메이션
 */

import React from 'react';

/**
 * TypingIndicator 컴포넌트
 *
 * - 3개의 점이 순차적으로 깜빡임
 * - 레트로 게임 스타일 픽셀 도트
 * - 부드러운 애니메이션
 */
export const TypingIndicator: React.FC = () => {
  return (
    <div className="flex items-center gap-1 px-4 py-3">
      {/* 도트 1 */}
      <div
        className="w-2 h-2 bg-[#0f380f] rounded-sm
                   animate-bounce"
        style={{ animationDelay: '0ms', animationDuration: '1s' }}
      />
      {/* 도트 2 */}
      <div
        className="w-2 h-2 bg-[#0f380f] rounded-sm
                   animate-bounce"
        style={{ animationDelay: '150ms', animationDuration: '1s' }}
      />
      {/* 도트 3 */}
      <div
        className="w-2 h-2 bg-[#0f380f] rounded-sm
                   animate-bounce"
        style={{ animationDelay: '300ms', animationDuration: '1s' }}
      />
    </div>
  );
};
